import React from "react";
import i18next from "i18next";
import { Box } from "@mui/material";
import styles from "./licensePlateComponent.module.scss";
import PropTypes from "prop-types";

const LicensePlateComponent = (props) => {
    const { platenumber } = props
    return(
        <Box className={styles.textWrapper} data-testid = 'licensePlate'>
              <Box className={styles.license}>{i18next.t("License plate")}</Box>
              <Box className={styles.licensevalues}>
                <Box className={styles.blueWrapper}>
                  <Box className={styles.plateNumber}>
                    <span className={styles.number}>
                      {platenumber}
                    </span>
                  </Box>
                </Box>
              </Box>
            </Box>
    )
}

export default LicensePlateComponent;
LicensePlateComponent.propTypes = {
  platenumber:PropTypes.any
}